/**
 * Contains configuration for the APIs.
 *
 * @export
 * @class ApiConfig
 */
export default class ApiConfig {
  public static readonly serverUrl = process.env.VUE_APP_API_BASE_URL;
}
